import * as fs from 'fs';
import * as path from 'path';
import { logger } from './utils/logger';

/**
 * Get the bundle directory from config or environment variable
 */
export function getBundleDir(configDir?: string): string {
  const bundleDir = configDir || process.env.SA_BUNDLE_DIR;

  if (!bundleDir) {
    throw new Error(
      'Bundle directory not configured. Please provide bundleDir in config or set SA_BUNDLE_DIR environment variable.'
    );
  }

  return bundleDir;
}

/**
 * Load the JavaScript bundle from the configured directory
 */
export function getJS(bundleDir: string): string {
  try {
    // Check if directory exists
    if (!fs.existsSync(bundleDir)) {
      throw new Error(`Bundle directory does not exist: ${bundleDir}`);
    }

    // Check if it's actually a directory
    const stats = fs.statSync(bundleDir);
    if (!stats.isDirectory()) {
      throw new Error(`Bundle path is not a directory: ${bundleDir}`);
    }

    // Read directory contents
    let files: string[];
    try {
      files = fs.readdirSync(bundleDir);
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : String(error);
      throw new Error(`Failed to read bundle directory: ${errorMessage}`);
    }

    // Find the bundle file
    const indexFile = files.find((file) => file.startsWith('index-') && file.endsWith('.js'));

    if (!indexFile) {
      logger.warn(`Available files in ${bundleDir}:`, files);
      throw new Error(
        `Could not find index-*.js file in ${bundleDir}. ` +
        `Expected a file matching pattern: index-*.js`
      );
    }

    // Read the bundle file
    const filePath = path.join(bundleDir, indexFile);
    logger.info(`Loading bundle from ${filePath}`);

    try {
      return fs.readFileSync(filePath, 'utf8');
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : String(error);
      throw new Error(`Failed to read bundle file: ${errorMessage}`);
    }
  } catch (error) {
    if (error instanceof Error) {
      logger.error('Failed to load bundle:', error.message);
    } else {
      logger.error('Failed to load bundle:', error);
    }
    throw error;
  }
}
